import { render, staticRenderFns } from "./IrisCollapsible.vue?vue&type=template&id=33bbaa3c&"
import script from "./IrisCollapsible.vue?vue&type=script&lang=ts&"
export * from "./IrisCollapsible.vue?vue&type=script&lang=ts&"
import style0 from "./IrisCollapsible.vue?vue&type=style&index=0&id=33bbaa3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports